import { render, staticRenderFns } from "./ProductMonthlyInvntry.vue?vue&type=template&id=5c306b71&scoped=true&"
import script from "./ProductMonthlyInvntry.vue?vue&type=script&lang=js&"
export * from "./ProductMonthlyInvntry.vue?vue&type=script&lang=js&"
import style0 from "./ProductMonthlyInvntry.vue?vue&type=style&index=0&id=5c306b71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c306b71",
  null
  
)

export default component.exports